module.exports = __webpack_public_path__ + "img/Eufloria.c49882c6.png";